import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import {
  GlobalTranslationContextProvider,
  GlobalTranslationFunction,
  ThemeProvider
} from '@ibe/components';

import { boot } from './Config/config';
import App from './App';
import initI18next from './Translations/setup';
import * as serviceWorker from './serviceWorker';
import { getTheme } from './Util/themeUtils';
import { LoadingOverlay } from './Components/Spinner/LoadingOverlay';
import NotAvailable from './Pages/NotAvailable';
import { useTranslation } from 'react-i18next';
import NotificationProvider from './Components/Toast/NotificationProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  try {
    await boot(false);
    await initI18next();
    const theme = await getTheme();

    if (theme) {
      root.render(
        <GlobalTranslationContextProvider
          globalTranslation={(useTranslation as unknown) as GlobalTranslationFunction}
        >
          <ThemeProvider theme={theme}>
            <div id="iso">
              <NotificationProvider></NotificationProvider>
              <Suspense fallback={<LoadingOverlay />}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </Suspense>
            </div>
          </ThemeProvider>
        </GlobalTranslationContextProvider>
      );
    }
  } catch (e) {
    const theme = await getTheme();
    if (theme) {
      root.render(
        <ThemeProvider theme={theme}>
          <div id="iso">
            <BrowserRouter>
              <NotAvailable />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      );
    }
  }
})();

serviceWorker.unregister();
